<template>
	<div class="container-fluid px-lg-2 px-xl-4">
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Facturas</li>
					</ol>
				</nav>
			</div>
		</div>
	
		<div>
			<div class="row d-md-none" ref="ancla">
				<div class="col-12">
					<span class="etiqueta">Desde:</span>
					<datepicker
						:format="format"
						:language="languages['es']"
						input-class="form-control form-control-sm font-12 bg-white"
						placeholder="Select Date"
						v-model="fechaInicio"
						wrapper-class="borderAzul"
					/>
				</div>
				<div class="col-12">
					<span class="etiqueta">Hasta:</span>
					<datepicker
						:format="format"
						:language="languages['es']"
						input-class="form-control form-control-sm font-12 bg-white"
						placeholder="Select Date"
						v-model="fechaFin"
						wrapper-class="borderAzul"
					/>
				</div>
				<div class="col-12">
					<span class="etiqueta">Tipo:</span>
					<select
						class="form-control form-control-sm borderAzul textControlesSize Combo font-12"
						v-model="tipoDocumento"
					>
						<option :key="item.valor" :value="item.valor" v-for="item in tipoDocumentos">{{item.nombre}}</option>
					</select>
				</div>
				<div class="col-12 mt-3">
					<div class="d-flex align-items-center">
						<button
						@click="consultarFacturas"
						class="btn borderAzul m-2 ColorAzul font-12 ButtonConsultar"
						>
							Consultar
						</button>
					</div>
				</div>
			</div>
			<div class="row d-md-flex align-items-center bg-white border ColorAzul d-none d-md-block">
				<span class="d-flex align-items-center">
					<span class="etiqueta">Desde:</span>
					<datepicker
						:format="format"
						:language="languages['es']"
						input-class="form-control form-control-sm font-12 bg-white"
						placeholder="Select Date"
						v-model="fechaInicio"
						wrapper-class="borderAzul m-2"
					/>
				</span>
				<span class="d-flex align-items-center">
					<span class="etiqueta">Hasta:</span>
					<datepicker
						:format="format"
						:language="languages['es']"
						input-class="form-control form-control-sm font-12 bg-white"
						placeholder="Select Date"
						v-model="fechaFin"
						wrapper-class="borderAzul m-2"
					/>
				</span>
				<span class="d-flex align-items-center">
					<span class="etiqueta">Tipo:</span>
					<select
						class="form-control form-control-sm borderAzul textControlesSize Combo font-12 m-2"
						v-model="tipoDocumento"
					>
						<option :key="item.valor" :value="item.valor" v-for="item in tipoDocumentos">{{item.nombre}}</option>
					</select>
				</span>
				
				<button
				@click="consultarFacturas"
				class="btn borderAzul m-2 ColorAzul font-12 ButtonConsultar"
				>Consultar</button>
				
			</div>
		</div>

		<div class="row mt-2">
			<!--tabla-->
			<b-table	:fields="fields"
				:items="resultadosMostrar"
				@row-selected="onRowSelected"
				hover
				id="my-table"
				ref="selectableTable"
				responsive
				selectable
				small
				sticky-header="700px"
				striped
			>
				<template v-slot:head(check)>
					<label class="container">
						<input @click="seleccionarTodos" type="checkbox" v-model="selectAll" />
						<span class="checkmark border"></span>
					</label>
				</template>

				<template v-slot:cell(check)="data">
					<label class="container">
						<input
							@click="agregaUno(data.index, data.rowSelected)"
							type="checkbox"
							v-model="data.rowSelected"
						/>
						<span class="checkmark border"></span>
					</label>
				</template>

				<template v-slot:cell(tipoDocumento)="data">
					{{data.item.tipoDocumento + data.item.folio + data.item.serie}}
					<br />
					{{tipoDocumentos.filter(tipo => tipo.valor == data.item.tipoDocumento)[0].nombre}}
				</template>
			</b-table>
		</div>

		<div class="row">
			<div class="col-12 pt-3 d-flex justify-content-center">
				<ul class="pagination">
					<li class="page-item " v-show="current_page > 1">
						<a @click="navegar(1)" class="page-link" role="button">«</a>
					</li>
					<li v-show="current_page > 1" class="page-item">
						<a
							@click="navegar(current_page-1)"
							class="page-link text-decoration-none d-none d-md-block"
							role="button"
						>Anterior</a>
					</li>
					<li :class="{active: current_page == pag}" :key="pag" class="page-item" v-for="pag in paginas">
						<a @click="navegar(pag)" class="page-link">{{pag}}</a>
					</li>
					<li class="page-item" v-show="current_page < numPages()">
						<a 	@click="navegar(current_page+1)" 
							class="page-link d-none d-md-block" 
							role="button">Siguiente</a>
					</li>
					<li class="page-item" v-show="current_page < numPages()">
						<a @click="navegar(numPages())" class="page-link" role="button">»</a>
					</li>
				</ul>
			</div>	
		</div>

		<!--paginacion-->
		<!-- <div class="row justify-content-center" v-if="rows>0">
			<nav aria-label="Page navigation">
				<ul class="pagination justify-content-center">
					<li class="page-item" v-show="current_page > 1">
						<a @click="navegar(1)" class="page-link" role="button">«</a>
					</li>
					<button @click="prevPage" v-show="current_page > 1" class="page-link fuentePaginador">‹ Anterior</button>
					
					<li :class="{active: current_page == pag}" :key="pag" class="page-item" v-for="pag in paginas">
						<a @click="navegar(pag)" class="page-link">{{pag}}</a>
					</li>

					<button @click="nextPage" v-show="current_page < numPages()" class="page-link fuentePaginador ml-2">Siguiente ›</button>
					
					<li class="page-item" v-show="current_page < numPages()">
						<a @click="navegar(numPages())" class="page-link" role="button">»</a>
					</li>
				</ul>
			</nav>
			<b-pagination
				per-page="1"
				:total-rows="rows"
				@change="cambiDePagina"
				aria-controls="my-table"
				class="mx-md-3"
				limit="5"
				next-text="Siguiente"
				prev-text="Anterior"
				v-model="currentPage"
			></b-pagination>
		</div> -->
		<hr />
		<div class="row">
			<div class="col-xs-12 col-sm-6 d-flex justify-content-center">
				<button @click="mostrarModal" class="btn Button m-2">Enviar por correo</button>
			</div>
			<div class="col-xs-12 col-sm-6 d-flex justify-content-center">
				<button @click="descargarFacturas" class="btn Button m-2">Descargar</button>
			</div>
		</div>
		<Pm-Facturas-Correos
			:correos="correos"
			:facturas="seleccionados"
			@agregarCorreo="agregarCorreo"
			@eliminarCorreo="eliminarCorreo"
			id="modal-1"
		></Pm-Facturas-Correos>
	</div>
</template>
<script>
	import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
	import * as lang from "vuejs-datepicker/src/locale"
	import servicioFacturas from "@/services/servicio-facturas"
	import PmFacturasCorreos from "@/components/clientes/FacturasCorreos"
	import Swal from "sweetalert2"
	import moment from "moment"

	export default {
		components: {
			Datepicker,
			PmFacturasCorreos,
		},
		data() {
			return {
				correos: [],
				codCliente: 0,
				languages: lang,
				format: "dd/MMM/yyyy",
				fechaInicio: new Date(),
				fechaFin: new Date(),
				tipoDocumento: "T",
				isBusy: false,
				facturas: [],
				tipoDocumentos: [
					{ valor: "T", nombre: "Todos" },
					{ valor: "F", nombre: "Factura" },
					{ valor: "P", nombre: "Complemento de pago" },
					{ valor: "C", nombre: "Nota de crédito" },
				],
				selectAll: false,
				seleccionados: [],
				fields: [
					{
						key: "check",
						label: "",
						thStyle: { background: "#335198", color: "#ffffff" },
					},
					{
						key: "tipoDocumento",
						thClass: "d-sm-table-cell d-md-none",
						tdClass: "d-sm-table-cell d-md-none",
						label: "Documento",
						thStyle: { background: "#335198", color: "#ffffff" },
					},
					{
						key: "fechaFactura",
						label: "Fecha",
						formatter: "formatoFecha",
						thStyle: { background: "#335198", color: "#ffffff" },
					},
					{
						key: "folio",
						label: "Documento",
						thClass: "d-none d-md-table-cell",
						tdClass: "d-none d-md-table-cell",
						formatter: (value, key, item) => {
							return item.tipoDocumento + item.folio + item.serie
						},
						thStyle: { background: "#335198", color: "#ffffff" },
					},
					{
						key: "serie",
						thClass: "d-none d-md-table-cell",
						tdClass: "d-none d-md-table-cell",
						label: "Tipo",
						formatter: (value, key, item) => {
							return this.tipoDocumentos.filter(
								(tipo) => tipo.valor == item.tipoDocumento
							)[0].nombre
						},
						thStyle: { background: "#335198", color: "#ffffff" },
					},
				],
				resultadosMostrar: [],
				//totalRows: 0,
				records_per_page: 20,
				current_page: 1,
				paginas:[]
			}
		},
		mounted() {
			//this.totalRows = this.facturas ? this.facturas.length : 0
			this.inicializar()
			this.consultarFacturas()
			this.colorEncabezado = "273C6E"
			this.obtenerNotificaciones()
		},
		computed: {
			rows() {
				return this.facturas.length
			},
		},
		methods: {
			agregarCorreo(correo) {

				if( this.correos.length >= 9 )
					return

				if(this.correos.find(element => element.correo == correo))
					return
				
				this.correos.push({ correo: correo })
				
				servicioFacturas
					.correosFrecuentesActualizar(this.correos)
					.then((r) => {
						this.correos = r.data
					})
					.catch((ex) => {
						console.log(ex)
					})
			},
			eliminarCorreo(correo) {
				this.correos.splice(this.correos.indexOf(correo), 1)

				servicioFacturas
					.correosFrecuentesActualizar(this.correos)
					.then((r) => {
						this.correos = r.data
					})
					.catch((ex) => {
						console.log(ex)
					})
			},
			seleccionarTodos() {
				if (!this.selectAll) {
					this.$refs.selectableTable.selectAllRows()
				} else {
					this.$refs.selectableTable.clearSelected()
				}
			},
			formatoFecha(value) {
				return moment(String(value)).format("DD/MMM/YYYY")
			},
			onRowSelected(items) {
				this.seleccionados = items
			},
			inicializar() {
				//var d = new Date('2019','08','01');
				var d = new Date()

				this.fechaInicio = d
				this.fechaInicio = new Date(d.getFullYear(), d.getMonth(), "01")
			},
			consultarFacturas() {
				this.$loading(true)
				servicioFacturas
					.consultarFacturas(this.fechaInicio, this.fechaFin, this.tipoDocumento)
					.then((r) => {
						this.$loading(false)
						this.facturas = r.data
						this.changePage()
					})
					.catch((ex) => {
						console.log(ex)
						this.$loading(false)
					})
			},
			navegar(pagina){
				this.current_page = pagina
				this.changePage()
			},
			prevPage() {
				if (this.current_page > 1) {
					this.current_page--
					this.changePage()
				}
			},
			nextPage() {
				if (this.current_page < this.numPages()) {
					this.current_page++
					this.changePage()
				}
			},
			changePage() {
				
				this.selectAll = false

				this.$nextTick(() => {
					this.resultadosMostrar = []
					this.inicio = this.current_page * this.records_per_page - this.records_per_page
					this.fin = this.current_page * this.records_per_page
					
					this.resultadosMostrar = this.facturas.slice(
						this.inicio,
						this.fin
					)
					this.scrollMeTo('ancla')
					this.paginadorBotones()
				})
			},
			paginadorBotones(){
				
				if (this.current_page == null || this.numPages() == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicioPaginado = this.current_page - aux > 0 ? this.current_page - aux : 1

				let finPaginado = this.current_page + aux > this.numPages() ? this.numPages() : this.current_page + aux

				for (let i = inicioPaginado; i <= finPaginado; i++) {
					res.push(i)
				}

				this.paginas = res
			},
			numPages() {
				return Math.ceil(this.facturas.length / this.records_per_page)
			},
			mostrarModal() {
				if (this.seleccionados.length > 0) {
					this.$loading(true)
					servicioFacturas
						.correosFrecuentesCon()
						.then((r) => {
							this.$loading(false)
							this.correos = r.data
						})
						.catch((ex) => {
							this.$loading(false)
							console.log(ex)
						})
					this.$bvModal.show("modal-1")
				}
			},
			descargarZip(base64){
				var link = document.createElement('a');
				link.download = 'facturas.zip';
				link.href= "data:application/zip;base64," + base64;
				link.textContent = 'Download Zip';
				link.click();
				document.body.appendChild(link);
			},
			descargarFacturas() {
				if (this.seleccionados.length > 0) {
					this.$loading(true)
					servicioFacturas
						.descargarFacturas(this.seleccionados)
						.then((r) => {
							this.$loading(false)
							//console.log(r)
							console.log(this.seleccionados);
							if (r.value) {
								// window.open("data:application/zip;base64," + r.data, "_blank")
								this.descargarZip(r.data)
								Swal.fire({
									text: r.message,
									icon: "success",
								})
							} else {
								Swal.fire({
									text: r.message,
									icon: "warning",
								})
							}
							this.$refs.selectableTable.clearSelected()
							this.selectAll = false
						})
						.catch((ex) => {
							this.$loading(false)
							Swal.fire({
								text: ex.message,
								icon: "error",
							})
							this.$refs.selectableTable.clearSelected()
							this.selectAll = false
						})
				}
			},
			agregaUno(index, value) {
				console.log(index + "-" + value)

				if (!value) {
					this.$refs.selectableTable.selectRow(index)
				} else {
					this.$refs.selectableTable.unselectRow(index)
				}
			},
			cambiDePagina() {
				this.selectAll = false
			},
		},
	}
</script>
<style scoped>
	/* The container */
	.container {
		display: block;
		position: relative;
		padding-left: 0px;
		margin-bottom: 25px;
		cursor: pointer;
		font-size: 22px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	/* Hide the browser's default checkbox */
	.container input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	/* Create a custom checkbox */
	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 25px;
		width: 25px;
		background-color: #eee;
	}

	/* On mouse-over, add a grey background color */
	.container:hover input ~ .checkmark {
		background-color: #ccc;
	}

	/* When the checkbox is checked, add a blue background */
	.container input:checked ~ .checkmark {
		background-color: var(--bg-yellow);
	}

	/* Create the checkmark/indicator (hidden when not checked) */
	.checkmark:after {
		content: "";
		position: absolute;
		display: none;
	}

	/* Show the checkmark when checked */
	.container input:checked ~ .checkmark:after {
		display: block;
	}

	/* Style the checkmark/indicator */
	.container .checkmark:after {
		left: 9px;
		top: 5px;
		width: 5px;
		height: 10px;
		border: solid white;
		border-width: 0 3px 3px 0;
		-webkit-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.encabezadoTabla {
		background: var(--bg-menu-blue);
	}
	.Button {
		width: 200px;
		background: var(--bg-menu-blue);
		color: white;
	}
	.Button:hover {
		background-color: var(--color-font-blue);
	}
	.styleCheck {
		width: 10px;
		height: 10px;
	}
	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}
	.ColorAzul {
		color: var(--bg-menu-blue);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.etiqueta {
			font-size: 14px !important;
		}
		.borderAzul {
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.ButtonConsultar:hover {
			background: var(--color-font-blue);
			color: white;
		}
		.ButtonConsultar {
			width: 100%;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.etiqueta {
			font-size: 14px !important;
		}
		.borderAzul {
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.ButtonConsultar:hover {
			background: var(--color-font-blue);
			color: white;
		}
		.ButtonConsultar {
			width: 100%;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.etiqueta {
			font-size: 14px !important;
		}
		.borderAzul {
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.Combo {
			width: 150px;
		}
		.ButtonConsultar:hover {
			background: var(--color-font-blue);
			color: white;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.etiqueta {
			font-size: 14px !important;
		}
		.borderAzul {
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.Combo {
			width: 150px;
		}
		.ButtonConsultar:hover {
			background: var(--color-font-blue);
			color: white;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.etiqueta {
			font-size: 14px !important;
		}
		.borderAzul {
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.Combo {
			width: 150px;
		}
		.ButtonConsultar:hover {
			background: var(--color-font-blue);
			color: white;
		}
	}
</style>